import { Eye, EyeOff } from "lucide-react";
import { setVisibleRoof } from "../redux/roomSlice";
import { useDispatch, useSelector } from "react-redux";

export default function RoofButton() {
    const dispatch = useDispatch();
    const visibleRoof = useSelector((state) => state.roomData.visibleRoof);

    return (
        <button className="roof-button" onClick={() => dispatch(setVisibleRoof())}>
            Cubierta
            {visibleRoof ? <Eye /> : <EyeOff />}
        </button>
    );
}
